import { createRouter, createWebHistory } from 'vue-router';
import { authStore } from '../stores/auth';

const routes = [
    {
        path: '/',
        component: () => import('../views/StartPage.vue'),
        meta: { guest: true },
    },
    {
        path: '/bankid',
        component: () => import('../views/BankIDLanding.vue'),
        meta: { guest: true },
    },
    {
        path: '/glomt-losenord',
        component: () => import('../views/ResetPassword.vue'),
        meta: { guest: true },
    },
    {
        path: '/registrera-dig',
        component: () => import('../views/RegistrationForm.vue'),
        meta: { guest: true },
    },

    /* ------- Logged in ------- */
    {
        path: '/synkronisering',
        component: () => import('../views/SyncLanding.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/avtal',
        component: () => import('../views/ContractList.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/fakturor',
        component: () => import('../views/InvoiceList.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/serviceanmalningar',
        component: () => import('../views/WorkorderList.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/serviceanmalningar/skapa-serviceanmalan',
        component: () => import('../views/CreateWorkorder.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/bokningar',
        component: () => import('../views/MyBookings.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/plusvalsbutiken',
        component: () => import('../views/OptionsShop.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/plusvalsbutiken/kundtjanst',
        component: () => import('../views/OptionsShopCustomerService.vue'),
        meta: { guest: true },
    },
    {
        path: '/prenumerationer',
        component: () => import('../views/MySubscriptions.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/erbjudanden',
        component: () => import('../views/OffersAndNotes.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/erbjudanden/detalj',
        component: () => import('../views/OfferDetails'),
        meta: { requiresAuth: true },
    },
    {
        path: '/erbjudanden/detalj/svarat',
        component: () => import('../views/OfferDetailsAnswered'),
        meta: { requiresAuth: true },
    },
    {
        path: '/profil',
        component: () => import('../views/ProfilePage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/profil/redigera',
        component: () => import('../views/EditProfile.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/uppdatera-losenord',
        component: () => import('../views/UpdatePassword.vue'),
        meta: { requiresAuth: true },
    },
];

const router = createRouter({
    history: createWebHistory('/mina-sidor/'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (authStore().loggedInStatus) {
            //
            authStore().queueAuthExtension();
            //
            next();
            return;
        }
        next('/?redirection=' + to.path);
    } else {
        next();
    }
});

export default router;
